import script from "./SaddleModule.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaddleModule.vue?vue&type=script&setup=true&lang=ts"

import "./SaddleModule.vue?vue&type=style&index=0&id=9e0ab68a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e0ab68a"]])

export default __exports__